import React from 'react';
import { Star } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
const TESTIMONIALS = [{
  quote: 'They treated our home like their own. The crew was respectful, the site was clean every evening, and the finish work is genuinely beautiful.',
  name: 'Margaret H.',
  project: 'Whole-home remodel'
}, {
  quote: 'Clear pricing, a real schedule, and no chasing anyone down. The kitchen came in on time and looks better than what we had drawn up.',
  name: 'David & Anne R.',
  project: 'Kitchen & bath'
}, {
  quote: 'We have used Taylor Company for three projects now. Same standard every time — that consistency is why we keep calling.',
  name: 'Jonathan P.',
  project: 'Exterior & built-ins'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bone-100 py-24 sm:py-32" aria-labelledby="testimonials-heading" data-id="element-213" data-mp="1znf6dkoe99y6">
      <div className="mx-auto max-w-[1320px] px-6 lg:px-10" data-id="element-214" data-mp="24kxh9glz1z8t">
        <div className="max-w-2xl" data-id="element-215" data-mp="38w40iipyw9wy">
          <SectionLabel data-id="element-216" data-mp="38v2g3nn2ab2k">Client Words</SectionLabel>
          <h2 id="testimonials-heading" className="mt-7 font-display text-4xl font-light leading-[1.05] text-pine-950 sm:text-5xl" data-id="element-217" data-mp="34vbqhn99u0zm">
            Work you can trust, from people who stay reachable.
          </h2>
        </div>

        <ul className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-218" data-mp="3dtnh3pa50ys2">
          {TESTIMONIALS.map(item => <li key={item.name} className="flex flex-col justify-between rounded-2xl border border-pine-900/10 bg-bone-50 p-8" data-id="element-219" data-mp="2l7ubz91dd824">
              <div data-id="element-220" data-mp="2v58s17jdrutw">
                <div className="flex gap-1" role="img" aria-label="Five out of five stars" data-id="element-221" data-mp="2v4qp5s27qid0">
                  {Array.from({
                length: 5
              }).map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-pine-700 text-pine-700" aria-hidden="true" data-id="element-222" data-mp="22fs34juyyw2f" data-mpi={i} />)}
                </div>
                <blockquote className="mt-7 font-display text-xl font-light leading-relaxed text-pine-950" data-id="element-223" data-mp="ba6pk30naqjt">
                  “{item.quote}”
                </blockquote>
              </div>
              <div className="mt-8 border-t border-pine-900/10 pt-5" data-id="element-224" data-mp="k6xtf1lfv9oy">
                <p className="text-sm font-medium text-pine-950" data-id="element-225" data-mp="3jl9wk5tqyxl0">{item.name}</p>
                <p className="mt-1 text-[11px] uppercase tracking-[0.16em] text-pine-950/45" data-id="element-226" data-mp="3oi9t9q4pinzg">
                  {item.project}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}